import { downloadAsExcel } from "../../../util/helperFunctions";

export const downloadUsageStats = async (dataToPlot, dataToPlot2) => {
    const sheets = [];

    if (dataToPlot?.length && dataToPlot[0]?.x?.length) {
        const downloadData = dataToPlot.map((ele) => {
            return ele.x.reduce(
                (prev, curr, index) => ({
                    ...prev,
                    [curr]: ele.y[index],
                }),
                { MonthYear: ele.name }
            );
        });

        sheets.push({ sheetName: 'MonthlyUsage', data: downloadData });
    }

    if (dataToPlot2?.length && dataToPlot2[0]?.x?.length) {
        const downloadData = dataToPlot2.map((ele) => {
            return ele.x.reduce(
                (prev, curr, index) => ({
                    ...prev,
                    [curr]: ele.y[index],
                }),
                { Page: ele.name }
            );
        });

        sheets.push({ sheetName: 'PageUsage', data: downloadData });
    }

    if (sheets.length > 0) {
        await downloadAsExcel(sheets, 'UsageStats.xlsx');
    }
};